import { app } from "../../bootstrap/core";
import { consorsUserInitState } from "./consorsUserInit.state";
import { consorsUserInitComponent } from "./consorsUserInit.component";
import { ConsorsUserInitService } from "./consorsUserInit.service";

app.config(consorsUserInitState);
app.service("consorsUserInitService", ConsorsUserInitService);
app.component(consorsUserInitComponent.name, consorsUserInitComponent);



// WEBPACK FOOTER //
// ./src/app/components/consorsUserInit/consorsUserInit.js